module.exports = __webpack_public_path__ + "img/fronius.bac21fb3.png";